/**
 * PageSkeleton - Beautiful loading placeholder for lazy-loaded pages.
 *
 * Uses the shimmer skeleton classes defined in global.css:
 *   .skeleton, .skeleton-text, .skeleton-text-short, .skeleton-card
 *
 * Mimics a typical dashboard page layout so the user sees a polished
 * content-shaped placeholder instead of a blank screen or spinner.
 */

const SkeletonMetricCard = () => (
  <div class="pskel-metric-card">
    {/* Label */}
    <div class="skeleton pskel-metric-label" />
    {/* Big number */}
    <div class="skeleton pskel-metric-number" />
    {/* Trend / subtitle */}
    <div class="skeleton pskel-metric-trend" />
  </div>
);

const SkeletonTableRow = (props: { columns: number }) => (
  <div class="pskel-row">
    {Array.from({ length: props.columns }).map((_, i) => (
      <div
        class={`skeleton pskel-row__cell${i === 0 ? " pskel-row__cell--first" : ""}${i === props.columns - 1 ? " pskel-row__cell--last" : ""}`}
      />
    ))}
  </div>
);

export const PageSkeleton = () => {
  return (
    <div class="pskel-page" role="status" aria-busy="true" aria-label="Loading page content">
      {/* ── Page Header ─────────────────────────────────── */}
      <div class="pskel-header">
        {/* Title */}
        <div class="skeleton pskel-header__title" />
        {/* Subtitle / breadcrumb */}
        <div class="skeleton pskel-header__subtitle" />
      </div>

      {/* ── Stats Row (4 metric cards) ──────────────────── */}
      <div class="pskel-stats-row">
        <SkeletonMetricCard />
        <SkeletonMetricCard />
        <SkeletonMetricCard />
        <SkeletonMetricCard />
      </div>

      {/* ── Content / Table Area ────────────────────────── */}
      <div class="pskel-table">
        {/* Table header */}
        <div class="pskel-table__header">
          <div class="skeleton pskel-table__header-cell pskel-table__header-cell--wide" />
          <div class="skeleton pskel-table__header-cell" />
          <div class="skeleton pskel-table__header-cell" />
          <div class="skeleton pskel-table__header-cell" />
        </div>

        {/* Table rows */}
        <SkeletonTableRow columns={4} />
        <SkeletonTableRow columns={4} />
        <SkeletonTableRow columns={4} />
        <SkeletonTableRow columns={4} />
        <SkeletonTableRow columns={4} />
        <SkeletonTableRow columns={4} />
      </div>
    </div>
  );
};
